module.exports = "/images/img_tshirt_2.png?313fa10072531568d4e176cbb139684f";